<ion-header>
  <ion-title size="large">Orders</ion-title>
  @if (isLoggedIn()) {
    <ion-segment mode="ios" [value]="selectedSegment()" (ionChange)="onSegmentChange($event)">
      @for (segment of segments(); track $index) {
        <ion-segment-button [value]="segment.value">
          <ion-label>{{ segment.label }}</ion-label>
        </ion-segment-button>
      }
    </ion-segment>
  }
</ion-header>

<ion-content>
  <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  
  @if (isLoggedIn()) {
    <div class="content-wrapper">
      @if (selectedSegment()==="active_orders" || selectedSegment()==="past_orders") {
        @for (order of filteredOrders(); track order.orderID) {
          <app-order-card [ngClass]="'cy-order-' + order.id" (click)="goToOrder(order)" [order]="order" mode="regular"></app-order-card>
        } @empty {
          <app-orders-empty />
        }
      } @else {
        @for (merge of combinedPrescriptions(); track $index) {
          <app-past-prescription-card [emitProfile]="true" (scriptItemProfileClick)="addPreviousScriptToCart($event)" (scriptItemClick)="goToScript($event)" [items]="merge.items" [medicalProfile]="merge.profile" />
        } @empty {
          <app-past-prescriptions-empty />
        }
      }
    </div>
  } @else {
    <app-login-placeholder title="No orders yet" description="Log in or Sign up to order scripts and pharmacy products." />
  }

</ion-content>